// AI-assisted: Claude 2026-08-07, human-reviewed: ausstehend
// Muster aus kraftbogen, erweitert um die Aktualitäts-Prüfung (Runde 17j).
import { registerSW } from "virtual:pwa-register"

export function initServiceWorker() {
  if (import.meta.env.DEV) return

  registerSW({
    immediate: true,
    onRegisteredSW(_url, registrierung) {
      if (!registrierung) return
      // Eine installierte App wird auf dem Handy nicht wirklich beendet — iOS
      // holt sie aus dem Ruhezustand zurück, ohne die Seite neu zu laden. Ein
      // Deploy kam dadurch erst an, wenn man sie aus der App-Übersicht
      // wegwischte. Genau daran ist die Suche nach dem Streifen unten
      // zweimal gescheitert: Thor hatte längst die alte Fassung im Speicher,
      // während der Server schon die neue auslieferte.
      // Deshalb: bei jeder Rückkehr in die App nachfragen, ob es etwas Neues
      // gibt. Der Service Worker lädt es im Hintergrund und startet die Seite
      // dann von selbst neu (registerType: "autoUpdate").
      const nachsehen = () => {
        if (document.visibilityState === "visible") void registrierung.update()
      }
      document.addEventListener("visibilitychange", nachsehen)
      window.addEventListener("focus", nachsehen)
    },
  })
}
